import axios from 'axios';

export const reqClient = axios.create({
	baseURL: process.env.REACT_APP_API,
	headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}
});
